import {
  FieldArrayItem,
  FileVariable,
} from "../../services/FacilitySettingsService";
import {FileReference} from "../../services/FileService";
import {getNormalizedHashId} from "../../utils/helpers/getNormalizedHashId";

/**
 * Constructs the FILE variable which can be saved to facility settings.
 */
export const makeFileVariable = (data: FileReference): FileVariable => ({
  ...data,
  type: "FILE",
});

export const getChecklistWithNormalizedIds = (
  checklist: ReadonlyArray<FieldArrayItem>,
) => {
  if (!Array.isArray(checklist)) {
    return undefined;
  }

  return checklist.reduce((acc, {checklistItemDescription, ...other}) => {
    const id = getNormalizedHashId(checklistItemDescription as string);

    if (acc.some((existing: {id: string}) => existing.id === id)) {
      return acc;
    }

    return [...acc, {...other, id, checklistItemDescription}];
  }, []);
};
